import { render, staticRenderFns } from "./hotkey.vue?vue&type=template&id=76520efa&"
import script from "./hotkey.vue?vue&type=script&lang=js&"
export * from "./hotkey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports